import { useEffect, useMemo, useState } from "react";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { PulseLoader } from "react-spinners";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useTranslation } from "react-i18next";

const LOCALE_MAP = {
  en: "en",
  "en-gb": "en-gb",
  "en-GB": "en-gb",
  fr: "fr",
  de: "de",
  es: "es",
  it: "it",
  nl: "nl",
  pl: "pl",
  pt: "pt",
  sv: "sv",
  ar: "ar",
  tr: "tr",
};

const DAYJS_LOCALE_LOADERS = {
  en: () => import("dayjs/locale/en"),
  "en-gb": () => import("dayjs/locale/en-gb"),
  fr: () => import("dayjs/locale/fr"),
  de: () => import("dayjs/locale/de"),
  es: () => import("dayjs/locale/es"),
  it: () => import("dayjs/locale/it"),
  nl: () => import("dayjs/locale/nl"),
  pl: () => import("dayjs/locale/pl"),
  pt: () => import("dayjs/locale/pt"),
  sv: () => import("dayjs/locale/sv"),
  ar: () => import("dayjs/locale/ar"),
  tr: () => import("dayjs/locale/tr"),
};

const normalizeToDayjsLocale = (lang) => {
  if (!lang) return "en";
  const lower = lang.toLowerCase();
  const primary = lower.split("-")[0];
  return LOCALE_MAP[lower] || LOCALE_MAP[primary] || "en";
};

const StepThree = (props) => {
  const { i18n, t } = useTranslation("makeBooking");
  const [localeReady, setLocaleReady] = useState(false);

  const days = props.barberWorkingDays;
  const today = dayjs();
  const todayString = `${today.$D}-${today.$M}-${today.$y}`;

  const dayjsLocale = useMemo(
    () => normalizeToDayjsLocale(i18n.language),
    [i18n.language]
  );

  useEffect(() => {
    let active = true;

    const load = async () => {
      const loader = DAYJS_LOCALE_LOADERS[dayjsLocale];
      if (loader) await loader();
      dayjs.locale(dayjsLocale);

      if (!active) return;

      setLocaleReady(true);

      if (props.defaultDate === undefined || props.defaultDate === null) {
        if (!props.barberWorkingDays.includes(0)) {
          props.queryDate(dayjs().add(0, "day"));
        } else {
          props.queryDate(dayjs().add(1, "day"));
        }
      } else {
        props.queryDate(props.defaultDate);
      }
    };

    setLocaleReady(false);
    load();

    return () => {
      active = false;
    };
  }, [dayjsLocale]);

  const defaultPickerDate =
    props.defaultDate === undefined || props.defaultDate == null
      ? dayjs().add(props.barberWorkingDays.includes(0) ? 1 : 0, "day")
      : props.defaultDate;

  return (
    <div className="booking-portal-step-wrapper">
      <div className="time-wrapper">
        {/* <div className="stepThreeHead"> */}





                  <div className="details-head">
          <IconButton
            aria-label={t("stepFour.actions.back")}
            size="small"
            className="details-backBtn"
                            onClick={() => {
                  props.goTo(1);
                  props.setAvailableTime("waiting");
                }}
          >
            <ArrowBackIcon className="details-backIcon" />
          </IconButton>
          <div className="details-titles">
            <h2 className="details-title">{t("stepThree.titles.selectTime")}</h2>
          </div>
        </div>



          {/* <div className="stepThreeHead__back">
            
            <IconButton aria-label={t("stepThree.actions.back")} size="large">
              <ArrowBackIcon
                className="back-arrow"
                onClick={() => {
                  props.goTo(1);
                  props.setAvailableTime("waiting");
                }}
              />
            </IconButton>
          </div> */}

          {/* <h2 className="grid-title">{t("stepThree.titles.selectTime")}</h2> */}
        {/* </div> */}

        {days === null ? (
          <div className="stepThreeLoading">
            <PulseLoader
              color={"#333"}
              loading={days === null}
              size={18}
              aria-label={t("stepThree.status.loadingAria")}
              data-testid="loader"
            />
          </div>
        ) : (
          <div className="stepThreeLayout">
            <section className="stepThreePanel stepThreePanel--calendar">
              <div className="stepThreePanel__head">
                <p className="stepThreeEyebrow">{t("stepThree.labels.selectDate")}</p>
              </div>

              {localeReady && (
                <LocalizationProvider
                  key={dayjsLocale}
                  dateAdapter={AdapterDayjs}
                  adapterLocale={dayjsLocale}
                >
                  <StaticDatePicker
                    key={`picker-${dayjsLocale}`}
                    defaultValue={defaultPickerDate}
                    disablePast
                    disableHighlightToday
                    maxDate={dayjs().add(2, "months")}
                    displayStaticWrapperAs="desktop"
                    slots={{
                      toolbar: () => null,
                      actionBar: () => null,
                    }}
                    onChange={(date) => {
                      props.queryDate(date);
                    }}
                    shouldDisableDate={(date) => {
                      const jsDow = date.toDate().getDay();

                      if (todayString === `${date.$D}-${date.$M}-${date.$y}` && days.includes(0)) {
                        return true;
                      }

                      const isWorkingDay = days.some((d) => d - 1 === jsDow);
                      return !isWorkingDay;
                    }}
                  />
                </LocalizationProvider>
              )}
            </section>

            <section className="stepThreePanel stepThreePanel--times">
              <div className="stepThreePanel__head">
                <p className="stepThreeEyebrow">{t("stepThree.labels.availableTimes")}</p>
                {/* <h3 className="stepThreePanel__title">{t("stepThree.titles.selectTime")}</h3> */}
              </div>

              {props.availableTimes === "waiting" ? (
                <div className="stepThreeTimesState">
                  <PulseLoader
                    color={"#333"}
                    loading={props.availableTimes === "waiting"}
                    size={12}
                    aria-label={t("stepThree.status.loadingAria")}
                    data-testid="loader"
                  />
                </div>
              ) : props.availableTimes === null ? (
                <div className="stepThreeTimesEmpty">
                  <p>{t("stepThree.status.noTimes")}</p>
                </div>
              ) : (
                <div className="stepThreeTimesGrid">
                  {props.availableTimes.map((availableTime, index) => (
                    <button
                      type="button"
                      key={index}
                      className="time-card"
                      onClick={() => {
                        props.goTo(3);
                        props.selectTime(availableTime.label);
                        props.selectTimeId(availableTime.value);
                      }}
                      aria-label={t("stepThree.actions.selectTimeSlot", {
                        time: availableTime.label,
                      })}
                    >
                      {availableTime.label}
                    </button>
                  ))}
                </div>
              )}
            </section>
          </div>
        )}
      </div>
    </div>
  );
};

export default StepThree;